import types from "../http_common";
import { apiRequest } from "../authConfig";

  async function bearerToken(instance) {
    const account = instance.getActiveAccount()
    if (!account) {
      throw Error(
        'No active account! Verify a user has been signed in and setActiveAccount has been called.'
      )
    }
    const response = await instance.acquireTokenSilent({
      ...apiRequest,
      account: account,
    })
   // console.log(response);
    return response.accessToken
  }
 
  const aiTest = async (payload) =>{
    var api = types.json();
   // const item = await bearerToken(instance);
  //  api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.post(`/ai/test`,payload);
  }

  const AgentApiService = {
       aiTest
  };
  
  export default AgentApiService;